const bookingConfirmationsList = [
  { name: "Instant confirmation", value: "INSTANT" },
  { name: "Instant confirmation then becomes manual", value: "INSTANT_THEN_MANUAL" },
  { name: "Manual confirmation", value: "MANUAL" },
];

export default bookingConfirmationsList;
